"use client";

import { LogIn, Phone } from "lucide-react";
import Link from "next/link";
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import sparksLocations from "@/constants/sparks_locations.json";

export default function Header() {
  const [open, setOpen] = useState(false);

  const handlePhoneClick = () => {
    setOpen(true);
  };

  return (
    <>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Give us a call today</AlertDialogTitle>
            <AlertDialogDescription>
              We would be more than happy to assist you and answer any questions
              that you may have!
            </AlertDialogDescription>

            <hr className="pt-4" />

            <div className="grid grid-cols-2 gap-4 mt-4">
              {sparksLocations.map((location, index) => (
                <div key={index}>
                  <h3 className="font-semibold">{location.address}</h3>

                  <address className="not-italic text-sm">
                    {location.type}
                    <br />

                    <a
                      href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
                        location.street +
                          ", " +
                          location.city +
                          ", " +
                          location.state
                      )}`}
                      className="italic"
                      target="_blank"
                    >
                      {location.street}
                    </a>

                    <br />

                    <a
                      href={`tel:+1${location.phone.replace(/\D/g, "")}`}
                      className="text-blue-500"
                    >
                      {location.phone}
                    </a>
                  </address>
                </div>
              ))}
            </div>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel className="bg-black hover:bg-slate-900 text-white hover:text-white">
              Exit
            </AlertDialogCancel>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      <div className="bg-[#222222]">
        <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
          <div className="flex-grow" />
          <Link href={"/consumer/login"}>
            <Button className="bg-transparent hover:bg-transparent text-white flex items-center ml-auto">
              Login
              <LogIn size={20} className="ml-1" />
            </Button>
          </Link>

          <Button 
            className="flex items-center bg-gray-400 hover:bg-gray-500 text-white p-2 rounded-md"
            onClick={handlePhoneClick}
          >
            <Phone size={20} />
          </Button>
        </div>
      </div>
    </>
  );
}
